import {
  CleanPurchaseOrder,
  PurchaseOrderWithRelations,
  RbacObject,
} from '../../../export-types/cleaned-types';
import { useIntl } from 'react-intl';
import { InputWrapper } from '../../common/input-wrapper';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { getPrefixByType } from '../../common/cards/id-cell-card.component';
import { ModalsService } from '../../../services/modals.service';
import { RelatedParcelsModal } from './related-parcels-modal';
import useSWR from 'swr';
import { fetcher } from '../../../services/api';
import { Rbac } from '../../common/Rbac';

export function PurchaseOrderRelatedParcels(props: {
  order: CleanPurchaseOrder;
}) {
  const intl = useIntl();

  const { data: relatedOrders } = useSWR<PurchaseOrderWithRelations>(
    `/purchase-order/${props.order.id}/relations`,
    fetcher,
  );

  const allRelated = [
    ...(relatedOrders?.parentOrder ? [relatedOrders.parentOrder] : []),
    ...(relatedOrders?.relatedPurchaseOrders || []),
  ];

  return (
    <>
      {
        <InputWrapper
          theme="light"
          className="mt-3"
          title={intl.formatMessage({
            defaultMessage: 'Связанные посылки',
            id: 'purchaseOrderRelatedParcels.label-input.relatedParcel',
            description: 'Информация о связанных посылках',
          })}
        >
          {allRelated.map((purchaseOrder, index) => {
            return (
              <NavLink
                to={`/${purchaseOrder.type === 'parcel' ? 'parcels' : 'purchases'}/${purchaseOrder.uuid}`}
              >
                {getPrefixByType(purchaseOrder.type)}
                {purchaseOrder.internalId}
                {index !== (allRelated?.length || 0) - 1 ? '; ' : ''}
              </NavLink>
            );
          })}
          <Rbac object={RbacObject.Parcel} action={'write:related-parcel'}>
            <button
              type="button"
              className="btn btn-success ms-2"
              onClick={() => {
                ModalsService.createModal(RelatedParcelsModal, {
                  orderId: relatedOrders?.parentOrder?.uuid
                    ? relatedOrders?.parentOrder.uuid
                    : props.order.id,
                });
              }}
            >
              +{' '}
              {intl.formatMessage({
                defaultMessage: 'Добавить',
                id: 'purchaseOrderRelatedParcels.label-input.addParcel',
                description: 'Кнопка',
              })}
            </button>
          </Rbac>
        </InputWrapper>
      }
    </>
  );
}
